'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.PushCart = PushCart;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _windowWidth = require('../../hooks/window-width');

var _functional = require('../../../utils/functional');

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _PushCartBody = require('./PushCartBody');

var _PushCartErrors = require('./PushCartErrors');

var _PushCartFooter = require('./PushCartFooter');

var _PushCartTopBar = require('./PushCartTopBar');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCart(_ref) {
  var _this = this;

  var action = _ref.action,
      submitTo = _ref.submitTo,
      recommendedProducts = _ref.recommendedProducts;

  var topBarRef = (0, _react.useRef)(null);
  var bodyRef = (0, _react.useRef)(null);
  var upsellRef = (0, _react.useRef)(null);
  var footerRef = (0, _react.useRef)(null);

  var _useWindowSize = (0, _windowWidth.useWindowSize)(),
      windowHeight = _useWindowSize.windowHeight;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      scrollableHeight = _useState2[0],
      setScrollableHeight = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      scrollableMaxHeight = _useState4[0],
      setScrollableMaxHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      currentUpsell = _useState6[0],
      setCurrentUpsell = _useState6[1];

  var errors = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.errors;
  });
  var loading = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.loading;
  });
  var lineItems = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.lineItems;
  });
  var itemCount = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.itemCount;
  });
  var subtotal = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.subtotal;
  });
  var emptyCart = window.theme.strings.pushCart.emptyCart;
  var continueShopping = window.theme.strings.pushCart.continueShopping;
  var cartIsEmpty = itemCount === 0;

  var displayDeliveryMessage = window.theme.booleans.displayDeliveryMessage;
  var isInFirstTier = subtotal >= window.theme.strings.pushCart.deliveryFirstTierMinimum && subtotal <= window.theme.strings.pushCart.deliveryFirstTierMaximum;
  var isInSecondTier = subtotal >= window.theme.strings.pushCart.deliverySecondTierMinimum && subtotal <= window.theme.strings.pushCart.deliverySecondTierMaximum;
  var deliveryMessage = isInSecondTier ? window.theme.strings.pushCart.deliverySecondTierMessage : isInFirstTier ? window.theme.strings.pushCart.deliveryFirstTierMessage.replace('[amount]', '<span class="psh-Delivery_Price">' + (0, _functional.formatMoney)(window.theme.strings.pushCart.deliverySecondTierMinimum - subtotal) + '</span>') : '';

  var dispatch = (0, _reactRedux.useDispatch)();

  var productsUpsellDisplay = window.theme.booleans.productsUpsellDisplay;
  var upsellProducts = recommendedProducts.flat();

  var getRecommendedProductPrice = function getRecommendedProductPrice(product) {
    var price = product.price;

    if (product.compare_at_price && product.compare_at_price < price) {
      price = product.compare_at_price;
    }

    return price;
  };

  var handleAddToCart = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(pushCartActions.addItemToCart({ id: id, quantity: 1, properties: {} }));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function handleAddToCart(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  function getScrollableHeight() {
    bodyRef.current.style.height = '';

    return windowHeight - topBarRef.current.offsetHeight - footerRef.current.offsetHeight;
  }

  function getScrollableMaxHeight() {
    return windowHeight - topBarRef.current.offsetHeight - footerRef.current.offsetHeight - upsellRef.current.offsetHeight;
  }

  (0, _react.useEffect)(function () {
    if (cartIsEmpty === false) {
      setScrollableHeight(getScrollableHeight());
      setScrollableMaxHeight(getScrollableMaxHeight());
    }
    (0, _functional.getElements)('[data-cart-count]').forEach(function (el) {
      el.textContent = itemCount;
    });
  }, [windowHeight, cartIsEmpty, itemCount]);

  if (cartIsEmpty) {
    return _react2.default.createElement('div', { className: 'psh-Cart' + (loading ? ' psh-Cart-loading' : '') }, _react2.default.createElement('div', { className: 'psh-Cart_Body', ref: bodyRef }, _react2.default.createElement('div', { className: 'psh-Cart_Empty' }, _react2.default.createElement('p', { className: 'psh-Cart_EmptyTitle', 'data-text': emptyCart }, emptyCart), _react2.default.createElement('button', { className: 'btn-Primary btn-Primary-light', 'data-module-drawers-close': 'cart' }, _react2.default.createElement('span', { className: 'btn-Primary_Text', 'data-text': continueShopping }, continueShopping)))));
  }

  return _react2.default.createElement('div', { className: 'psh-Cart' + (loading ? ' psh-Cart-loading' : '') }, errors.length > 0 && _react2.default.createElement('div', { className: 'psh-Cart_Errors' }, _react2.default.createElement(_PushCartErrors.PushCartErrors, { errors: errors })), _react2.default.createElement('header', { className: 'psh-Cart_TopBar', ref: topBarRef }, _react2.default.createElement(_PushCartTopBar.PushCartTopBar, {
    title: window.theme.strings.pushCart.title,
    cartTotalOverview: window.theme.strings.pushCart.cartTotalOverview
  })), _react2.default.createElement('div', {
    className: 'psh-Cart_Body',
    ref: bodyRef,
    style: {
      height: scrollableHeight + 'px'
    }
  }, _react2.default.createElement('div', {
    className: 'psh-Cart_Body-items',
    style: {
      maxHeight: scrollableMaxHeight + 'px'
    }
  }, _react2.default.createElement(_PushCartBody.PushCartBody, { lineItems: lineItems })), _react2.default.createElement('div', { className: 'psh-Cart_Body-upsell', ref: upsellRef }, displayDeliveryMessage && deliveryMessage !== '' && _react2.default.createElement('div', { className: 'psh-CartBody_MessageDelivery' }, _react2.default.createElement('p', {
    className: 'psh-CartBody_MessageDelivery-text',
    dangerouslySetInnerHTML: { __html: deliveryMessage }
  })), productsUpsellDisplay && upsellProducts.length > 0 && !isInSecondTier && _react2.default.createElement('div', { className: 'psh-CartBody_Upsell' }, _react2.default.createElement('h3', { className: 'psh-CartBody_Upsell-title' }, window.theme.strings.pushCart.pushCartUpsellTitle), _react2.default.createElement('div', { className: 'psh-CartBody_UpsellContainer' }, currentUpsell > 0 && _react2.default.createElement('button', {
    className: 'psh-CartBody_Upsell-buttonPrevious',
    onClick: function onClick() {
      return setCurrentUpsell(Math.max(currentUpsell - 1, 0));
    }
  }, _react2.default.createElement('svg', { viewBox: '0 0 9 8', xmlns: 'http://www.w3.org/2000/svg' }, _react2.default.createElement('g', {
    transform: 'rotate(135 3.182 3.682)',
    fill: 'currentColor',
    fillRule: 'evenodd'
  }, _react2.default.createElement('rect', {
    transform: 'rotate(90 2.5 4.5)',
    x: '2',
    y: '2',
    width: '1',
    height: '5',
    rx: '.5'
  }), _react2.default.createElement('rect', {
    transform: 'rotate(90 4.5 2.5)',
    x: '2',
    y: '2',
    width: '5',
    height: '1',
    rx: '.5'
  })))), currentUpsell < upsellProducts.length - 1 && _react2.default.createElement('button', {
    className: 'psh-CartBody_Upsell-buttonNext',
    onClick: function onClick() {
      return setCurrentUpsell(Math.min(currentUpsell + 1, upsellProducts.length - 1));
    }
  }, _react2.default.createElement('svg', { viewBox: '0 0 11 11', xmlns: 'http://www.w3.org/2000/svg' }, _react2.default.createElement('g', {
    transform: 'scale(1 -1) rotate(-45 -6.361 -3.42)',
    fill: 'currentColor',
    fillRule: 'evenodd'
  }, _react2.default.createElement('rect', {
    transform: 'rotate(90 3.5 6.5)',
    x: '3',
    y: '3',
    width: '1',
    height: '7',
    rx: '.5'
  }), _react2.default.createElement('rect', {
    transform: 'rotate(90 6.5 3.5)',
    x: '3',
    y: '3',
    width: '7',
    height: '1',
    rx: '.5'
  })))), _react2.default.createElement('div', {
    className: 'psh-CartBody_Upsell-items',
    style: { left: currentUpsell * -300 + 'px' }
  }, upsellProducts.map(function (product, idx) {
    return _react2.default.createElement('div', { className: 'psh-CartBody_Upsell-item', key: 'item-' + idx }, _react2.default.createElement('a', { className: 'psh-CartBody_Upsell-imageContainer', href: product.url }, _react2.default.createElement('img', {
      className: 'psh-CartBody_Upsell-image',
      src: (0, _functional.resizeImage)({ src: product.featured_image, size: '120x120' }),
      alt: product.title
    })), _react2.default.createElement('div', { className: 'psh-CartBody_Upsell-content' }, _react2.default.createElement('h5', { className: 'psh-CartBody_Upsell-itemTitle' }, _react2.default.createElement('a', { className: 'psh-CartBody_Upsell-itemTitleLink', href: product.url }, product.title)), _react2.default.createElement('p', {
      className: 'psh-CartBody_Upsell-price',
      dangerouslySetInnerHTML: {
        __html: (0, _functional.formatMoney)(getRecommendedProductPrice(product))
      }
    }), _react2.default.createElement('div', { className: 'psh-CartBody_Upsell-buttons' }, product.variants.length > 1 && _react2.default.createElement('p', { className: 'psh-CartBody_Upsell-buttonPrefix' }, window.theme.strings.addToCart, ' :'), product.variants.map(function (variant) {
      return _react2.default.createElement('button', {
        key: variant.id,
        type: 'button',
        className: 'psh-CartBody_Upsell-button',
        onClick: function onClick() {
          return handleAddToCart(variant.id);
        },
        disabled: variant.inventory_quantity < 1
      }, product.variants.length > 1 ? variant.title : variant.inventory_quantity < 1 ? window.theme.strings.soldOut : window.theme.strings.addToCart);
    }))));
  })))))), _react2.default.createElement('footer', { className: 'psh-Cart_Footer', ref: footerRef }, _react2.default.createElement(_PushCartFooter.PushCartFooter, {
    action: action,
    submitTo: submitTo,
    footerMessage: window.theme.strings.pushCart.footerMessage,
    subtotal: subtotal
  })));
}

PushCart.propTypes = {
  action: _propTypes2.default.string.isRequired,
  submitTo: _propTypes2.default.string.isRequired,
  recommendedProducts: _propTypes2.default.array.isRequired
};

PushCart.defaultProps = {};